import { NgModule } from '@angular/core';
import { RegionsRoutingModule } from './regions-routing.module';
import { ManageRegionsComponent } from './manage-regions/manage-regions.component';
import { HomeModule } from '../home/home.module';
import { MaterialModule } from '../material/material.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';


@NgModule({
  declarations: [ ManageRegionsComponent],
  imports: [
    RegionsRoutingModule,
    HomeModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
  ]
})
export class RegionsModule { }
